export function useLocalStorage(key: string) {
  function get(): string | null {
    return localStorage.getItem(key);
  }

  function save(value: string): void {
    localStorage.setItem(key, value);
  }

  function remove(): void {
    localStorage.removeItem(key);
  }

  return { get, save, remove };
}
